module.exports = __webpack_public_path__ + "static/media/airsweb-logo-charcoal.f4ec56cc.svg";